import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class OportunidadeInteracoesService {
	constructor(private apiService: ApiService) {}

	getAll(filtro?): Observable<any> {
		const url = `/oportunidade-interacoes`
		return this.apiService.get(url, filtro)
	}

	get(id: number): Observable<any> {
		const url = `/oportunidade-interacoes/${id}`
		return this.apiService.get(url)
	}

	post(form): Observable<any> {
		return this.apiService.post('/oportunidade-interacoes', form)
	}

	put(id: number, form): Observable<any> {
		form._method = 'PUT'
		return this.apiService.post('/oportunidade-interacoes/' + id, form)
	}

	delete(id): Observable<any> {
		return this.apiService.delete('/oportunidade-interacoes/' + id)
	}
}
